// app/javascript/controllers/vehicle_profile_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["subButton","name", "driver", "capacity", "colorMakeModel"];


  connect() {
    console.log('connected vehicle profile')
    this.element.addEventListener("submit", (event) => {
      this.disableButton()
    })
 
    this.updateProfile(); // Initial update in case there are default values

  }


  disableButton() {
    console.log('submitted')
    this.subButtonTarget.disabled = true

    console.log("here",this.subButtonTarget)
    this.subButtonTarget.innerHTML = `
      <i class="fa-solid fa-spinner fa-spin mr-2"></i>
      Saving...
    `
  }  

  capitalizeWords(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  }

  updateProfile() {
    const t_name = this.capitalizeWords(this.element.querySelector("#vehicle_general_info\\[name\\]").value || 'Truck Name') ;

    const t_color = this.capitalizeWords(this.element.querySelector("#vehicle_general_info\\[color\\]").value || 'Color') ;
    const t_make = this.capitalizeWords(this.element.querySelector("#vehicle_general_info\\[make\\]").value || 'Make') ;
    const t_model = this.capitalizeWords(this.element.querySelector("#vehicle_general_info\\[model\\]").value || 'Model') ;

    const t_driver = this.capitalizeWords(this.element.querySelector("#vehicle_status_info\\[assigned_driver\\]").value || 'Driver') ;

    const t_capacity = this.capitalizeWords(this.element.querySelector("#vehicle_specifications\\[storage_size\\]").value || 'Storage size') ;

  
 

    this.nameTarget.textContent = `${t_name}`;

    this.colorMakeModelTarget.textContent =`${t_color} ${t_make} ${t_model}`
    this.driverTarget.textContent = `${t_driver}`;
    this.capacityTarget.textContent= `${t_capacity}`

    console.log(t_name);
  }


}
